<button type="button" class="basket-preview button button--th-ctrl" (click)="onOpenBasket()" [ngClass]="{ 'is-fill': totalCount$ | async }">
  <span class="basket-preview__icon">
    <i class="icomoon icomoon--cart"></i>
  </span>
  <span class="basket-preview__text" i18n="@@Basket">Basket</span>
  <span class="basket-preview__total" *ngIf="totalPrice$ | async as totalPrice">
    <app-price [price]="totalPrice"></app-price>
  </span>
</button>

<div class="modal l-wrapper" *ngIf="isShowBasket">
  <div  class="modal__overlay" (click)="onClose()"></div>
  <div class="modal__container">
    <div class="modal__content">
      <div class="modal__head l-wrapper">
        <div class="modal__close">
          <button class="button-icon button-icon--th-ctrl" (click)="onClose()">
            <i class="icomoon icomoon--arrow-left"></i>
          </button>
        </div>
        <div class="modal__title h1" i18n="@@Basket">Basket</div>
        <div class="modal__right">
          <button type="button" class="link link--th-ctrl link--underline-in" i18n="@@Clear" (click)="onClear()">Clear</button>
        </div>
      </div>
      <div class="modal__body l-wrapper">
        <app-basket-mini (emptyBasket)="onClear()"></app-basket-mini>
      </div>
      <div class="modal__footer l-wrapper" *ngIf="!isOrderingPage">
        <button routerLink="/ordering" class="button button--th-main _rounded" type="button" (click)="onClose()">
          <span class="button__text" i18n="@@ToOrder">To order</span>
          <span class="button__label" *ngIf="totalPrice$ | async as totalPrice">
            <app-price [price]="totalPrice"></app-price>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>


